import React, { useContext, useState, useEffect } from 'react'
import Image from "next/image"
import ClassNames from 'classnames'

import Typography from 'Atoms/Typography'
import Area from 'Molecules/Area'
import Panel from 'Atoms/Panel'
import Button from 'Molecules/Button'
import Drawer from 'Molecules/Drawer'
import IndexOptions from '../../Components/IndexOptions/indexoptions.js'
import styles from './VariantDetailsDrawer.module.scss'
import { AddToCartExperienceContext } from '../../Contexts/AddToCartExperienceContext/AddToCartExperienceContext.js'

const VariantDetailsDrawer = () => {
    const { product,
        isVariantDetailsDrawerOpen,
        isVariantDetailsDrawerAtc,
        hideVariantDetailsDrawer,
        handleIndexOptionSelectionVDD,
        isIndexOptionErrorState,
        handleAddToListVDD,
        handleAddToCartVDD
    } = useContext(AddToCartExperienceContext)

    const [waiting, setWaiting] = useState(false)

    useEffect(() => {
        if (!isVariantDetailsDrawerOpen || isIndexOptionErrorState)
            setWaiting(false)
    }, [isVariantDetailsDrawerOpen, isIndexOptionErrorState])

    if (!product) return null

    const { productPageId, indexOptions, title, imageUrl } = product

    const notPurchaseable = isVariantDetailsDrawerAtc && product.isPurchaseable == false

    return (
        <Drawer
            portalId={'variantDetailsDrawer'}
            location={'right'}
            width={640}
            open={isVariantDetailsDrawerOpen}
            closeFunction={hideVariantDetailsDrawer}>
            <div className={styles.variant_drawer} data-testid={''}>
                <Typography size={1.25} font={'heading'} className={styles.center}>
                    {isVariantDetailsDrawerAtc ? "Add to Cart" : "Add to List"}
                </Typography>
                <Panel className={styles.variant_drawer_panel} layer={0}>
                    <div className={styles.imageWrapper}>
                        <Image
                            src={`https:${imageUrl
                                ? imageUrl
                                : "//content.speedwaymotors.com/OtherImages/missingimage2.jpg"
                                }`}
                            alt={title}
                            width={250}
                            height={250}
                        />
                    </div>
                    {indexOptions && indexOptions.length > 0 ?
                        <IndexOptions
                            selectIndexOption={handleIndexOptionSelectionVDD}
                            indexOptions={indexOptions}
                            productPageId={productPageId}
                            buttonCuttoffValue={5}
                            isIndexOptionErrorState={isIndexOptionErrorState}
                        />
                        : null}
                    <div className={ClassNames(styles.center, styles.variant_drawer_atc)}>     
                        {notPurchaseable ? <Typography size={1} intent={'negative'} className={styles.notAvailable}>This item is currently not available.</Typography> : <div className={styles.filler}/> }                
                        <Button
                            intent={'positive'}
                            disabled={notPurchaseable || isIndexOptionErrorState}
                            text={isVariantDetailsDrawerAtc ? 'Add to Cart' : 'Add to a List'}
                            size={'small'}
                            event={{}}
                            isWaiting={waiting}
                            testingName={isVariantDetailsDrawerAtc ? 'ATC_drawer_button' : 'ATL_drawer_button'}
                            onClick={(e) => {
                                e.preventDefault();
                                setWaiting(true);
                                isVariantDetailsDrawerAtc ? handleAddToCartVDD() : handleAddToListVDD()
                            }}
                        ></Button>

                    </div>
                </Panel>
            </div>
        </Drawer>
    )
}

export default VariantDetailsDrawer
